import { FieldSubscription } from 'final-form'
import { get } from 'lodash'
import React from 'react'
import { Field } from 'react-final-form'

export type TFields = {
  names?: string[]
  prefix?: string
  subscription?: FieldSubscription
  fieldsState?: {
    [key: string]: any
  }
  children?: React.FC<any>
  originalRender?: React.FC<any>
}

const Fields = ({
  names = [],
  prefix,
  subscription,
  fieldsState = {},
  children,
  originalRender,
}: TFields): React.ReactElement => {
  if (!names.length) {
    return (originalRender || (children as any))(fieldsState)
  }
  const [name, ...rest] = names

  const key = prefix ? `${prefix}.${name}` : name

  return (
    <Field name={key} subscription={subscription}>
      {(fieldState) => (
        <Fields
          names={rest}
          prefix={prefix}
          subscription={subscription}
          originalRender={originalRender || children}
          fieldsState={{
            ...fieldsState,
            [name]: get(fieldState, 'input.value'),
          }}
        />
      )}
    </Field>
  )
}

export default Fields
